<div class="add-message-reply pl-20 mb-2 mb-4 relative w-full lendio-density-2">
    <!-- Input -->
    <textarea
        [formControl]="replyFormControl"
        class="add-message-reply-area rounded-lg text-lendio-black placeholder-color-warm-gray-400 w-full px-2 py-[7px]"
        type="text"
        placeholder="Reply to this message&hellip;"
        appTextareaAutoresize></textarea>
        
        <!-- Send button/Saving spinner -->
        @if (isSaving()) {
            <mat-spinner class="!absolute right-2 bottom-[16px]" [diameter]="16" />
        } @else {
            <button
            mat-icon-button
            class="!absolute right-1 bottom-[11px]"
            (click)="addReply(replyFormControl.value)"  
            color="accent"
            [disabled]="replyFormControl.invalid">
            <mat-icon class="material-icons-outlined">send</mat-icon>
        </button>
    }
</div>
<!-- Validation errors -->
@if (replyFormControl.hasError('maxlength') || replyFormControl.hasError('serverError')) {
    <div class="h-6 add-message-validation-error">
        @if (replyFormControl.hasError('maxlength')) {
            <mat-error class="ml-20 -mt-[15px]"> Reply exceeds maximum length.</mat-error>
        } @if (replyFormControl.hasError('serverError')) {
            <mat-error class="ml-20 -mt-[15px]">
                An error occurred while sending the reply.
            </mat-error>
        }
    </div>
}